import { reducerWithInitialState } from 'typescript-fsa-reducers';
import { pageOpenAction } from '@app/react/action/PageOpenDetectionAction';
import { ORDER_PARTS } from '@app/react/const/variables';

interface IinitStatePageOpenDetection {
    open: boolean;
    partsName: typeof ORDER_PARTS[number] | null;
}
const initState: IinitStatePageOpenDetection = {
    open: false,
    partsName: null,
};

export const pageOpenDetectionReducer = reducerWithInitialState(initState)
    .case(pageOpenAction, (state, { partsName }) => ({
        ...state,
        open: partsName !== null,
        partsName,
    }));
